<template>
  <div class="w-full text-white bg-black">
    <ModalGroups />
    <!-- ao vivo -->
    <section class="px-6 md:px-20 py-10 md:mt-10">
      <div class="text-left border-b border-gray-600">
        <h1 class="text-4xl md:text-5xl font-bold mb-2">
          MEUS CERTIFICADOS
        </h1>
        <!-- <p class="text-lg md:text-xl"> certificados dos cursos já conlcuidos </p> -->
      </div>

      <div class="w-full py-3">
        AINDA NÃO HÁ CERTIFICADOS AQUI...
      </div>

    </section>

    <!-- TURMAS -->
    <section class="px-6 md:px-20 py-10" v-if="user?.role == 'manager'">
      <h2 class="text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
        EQUIPES
      </h2>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 uppercase" v-if="groupsManager?.length">
        <!-- <Carrossel> -->
          <NewsCard
            v-for="(item, index) in groupsManager"
            :key="index"
            :image="appBanner"
            :title="item.name"
            :description="item.description"
            :students="item.customers?.length"
            @click="seeGroup(item)"
          />
        <!-- </Carrossel> -->
      </div>

      <div class="w-full py-3" v-else>
        VOCÊ AINDA NÃO POSSUÍ GRUPOS...
      </div>
    </section>

    <!-- MAIS ANTIGOS -->
    <!-- <section class="px-6 md:px-20 py-10">
      <h2 class="text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
        EVENTOS MAIS ANTIGOS
      </h2>

      <div v-if="lastEvents?.older?.length">
        <Carrossel>
          <CardEventoPreview
            v-for="(item, index) in lastEvents?.older"
            :key="index"
            :image="item.banner !== null && item.banner !== '[]' ? fileUrl + item.banner : banner"
            :title="item.title"
            :date="formatDate(item.date)"
            :live="item.is_live"
            @click="watchEvent(item)"
          />
        </Carrossel>
      </div>
      <div class="w-full py-3" v-else>
        Ainda não há eventos antigos
      </div>
    </section> -->

  </div>
</template>

<script setup>
import { onBeforeMount, computed } from 'vue'
import { dataShared } from '@/shared/store'
import NewsCard from '../auth/components/NewsCard.vue'
import appBanner from './../../../assets/logo/icon.png'
import ModalGroups from '@/shared/components/__partials/ModalGroups.vue'
import 'moment/locale/pt-br'

const groupsManager = computed(() => dataShared.getters.getDataGroupManager)
const user = computed(() => dataShared.getters.getDataByUserLogged)

async function seeGroup (payload) {
  dataShared.dispatch('setModalOpen', true)
  dataShared.dispatch('setDataModalOpen', payload)
}

async function groups () {
  dataShared.dispatch('setDataGroupManager')
  dataShared.dispatch('desactiveLoading')
}

onBeforeMount(async () => {
  await dataShared.dispatch('fetchLoggedUser')
  window.scrollTo(0, 0)

  Promise.all([
    groups()
  ])
})
</script>

<style lang="scss" scoped>
p {
  margin: 10px 0;
}
</style>
